import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/exam_title.png'


const _withScopeId = n => (_pushScopeId("data-v-4e0731d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = {
  key: 0,
  class: "examPaperLoadingMask"
}
const _hoisted_3 = { class: "examPaperLoadingText" }
const _hoisted_4 = { class: "dvContent" }
const _hoisted_5 = { class: "dvTop" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeft" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftLogo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dvTopLeftLogoImg",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftTitle ml1" }, "正式测评")
], -1))
const _hoisted_7 = { class: "dvTopRightBtn" }
const _hoisted_8 = { class: "dvMid" }
const _hoisted_9 = { class: "dvMidTop" }
const _hoisted_10 = {
  key: 0,
  class: "dvCoverList"
}
const _hoisted_11 = { class: "dvCoverTitle mt30" }
const _hoisted_12 = {
  key: 1,
  class: "dvCoverList"
}
const _hoisted_13 = { class: "dvCoverTitle mt20" }
const _hoisted_14 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.examPaperLoading == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.examPaperLoadingText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btnViewHistory",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToExamRecord && _ctx.goToExamRecord(...args)))
          }, " 查看历史记录 ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (!_ctx.isExam)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.noExamTxt), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.examData.name), 1),
                _createElementVNode("button", {
                  class: "btnStartExam mt18",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startExam && _ctx.startExam(...args)))
                }, " 开始测评 ")
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "btnBack",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
        }, "返 回")
      ])
    ])
  ]))
}